var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.isAuthenticated)?_c('div',[_vm._v(" Logged in as "+_vm._s(_vm.$store.state.user.displayName)+" "),_c('div',[_c('LogoutButton')],1)]):_c('div',[_vm._v(" Not logged in "),_c('LoginButton')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }